import { faKey, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import UserAuthKeys from './UserAuthKeys';
import useStyles from './UserAuthKeys.styles';
import type { UserAuthKeysDialogProps } from './UserAuthKeys.types';

const UserAuthKeysDialog = ({
  open,
  onClose,
  userId,
  userName
}: UserAuthKeysDialogProps) => {
  const { classes } = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <FontAwesomeIcon icon={faKey} /> API Keys - {userName}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        className={classes.closeButton}
      >
        <FontAwesomeIcon icon={faXmark} />
      </IconButton>
      <DialogContent className={classes.authKeysDialog} sx={{ py: 2 }}>
        <UserAuthKeys userId={userId} />
      </DialogContent>
    </Dialog>
  );
};

export default UserAuthKeysDialog;
